import api from './api';

export const getNotifications = (page = 1) => api.get(`/notifications?page=${page}`);
export const getUnreadCount = () => api.get('/notifications/unread-count');
export const markAsRead = (id) => api.patch(`/notifications/${id}/read`);
export const markAllAsRead = () => api.patch('/notifications/read-all');